module.exports = __webpack_public_path__ + "img/ic-freind.8e9a9d08.svg";